import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Upload, Button, Icon, Select, Avatar, Modal, Spin, message,
} from 'antd';
import { photo_types, photos_types_styles } from '../statics';
import { getLeadProfilePhotosRequest, uploadLeadProfileRequest, deleteLeadProfilePhotosRequest } from '../../redux/actions/lead_profile_photos.actions';
import { getVal } from '../../../../../shared/helpers';

const { Option } = Select;

const mapStateToProps = state => ({
    photos: state.Leads.Lead_profile.Lead_photos.photos,
    loading: state.Leads.Lead_profile.Lead_photos.loading,
    lead_id: state.Leads.Lead_profile.Lead_general.root_id,
    blemish_report: state.Leads.Lead_profile.Lead_blemish_report.blemish_report,
    userGroups: getVal(state, 'App.App_content.user.groups'),
});

export default connect(mapStateToProps, null)(class LeadProfilePhotos extends Component {
    lead_id = this.props.lead_id || window.location.pathname.slice(-24);

    state = {
        photo_type: '',
        blemish_report_question_for_photo: undefined,
        photo_address: '',
        id: '',
        visible: false,
        photos: [],
    };

    blemishReportStatus = (blemish_report) => {
        let currentStatus = null;
        if (blemish_report.ref_lead_blemish_report_status === '5c6bb312b8292a22d8128dfb') {
            currentStatus = 'Pending';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb355b8292a22d8128dfc') {
            currentStatus = 'In Progress';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb367b8292a22d8128dfd') {
            currentStatus = 'Waiting For Approval';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb37fb8292a22d8128dfe') {
            currentStatus = 'Complete';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb394b8292a22d8128dff') {
            currentStatus = 'Failed';
        }

        return currentStatus;
    };

    chooseBlemishReportQuestionForPhoto = question => this.setState({ blemish_report_question_for_photo: question });

    choosePhotoType = (photo_type) => {
        if (photo_type === 'Blemish Report') {
            this.setState({ photo_type });
        } else {
            this.setState({ photo_type, blemish_report_question_for_photo: undefined });
        }
    };

    photoUploadHandler = (event) => {
        if (event.file && event.file.size >= 60291456) {
            message.warn('Please, select file with size less them 6MB');
        } else {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(event.file);
            fileReader.addEventListener('load', () => this.props.dispatch(uploadLeadProfileRequest(this.lead_id, this.state.photo_type, fileReader.result, this.state.blemish_report_question_for_photo)));
        }
    };

    showModalForAvatar = (e) => {
        this.setState({ photo_address: e.target.src, id: e.target.getAttribute('data-id'), visible: true });
    };

    handleCancel = () => this.setState({ visible: false });

    changePhoto = (e) => {
        e.preventDefault();
        this.setState({ photo_address: e.target.getAttribute('data-picture'), visible: true });
    }

    deletePhoto = (e) => {
        e.preventDefault();
        let { photos } = this.props;
        const index = parseInt(e.target.getAttribute('data-id'));

        photos = photos.splice(index, 1);

        this.props.dispatch(deleteLeadProfilePhotosRequest(this.lead_id, photos, index));
        this.setState({ visible: false });
        const _self = this;
        setTimeout(() => {
            _self.props.dispatch(getLeadProfilePhotosRequest(_self.lead_id));
        }, 4000);
    }

    render() {
        let { photos, loading } = this.props;
        const driver_photos = []; const advert_photos = []; const br_photos = []; const
            settlement_docs = [];
        const is_user_admin_or_super_user = this.props.userGroups.some(group => group._id === '5d7f6909bdee754d2fc96667' || group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024');

        photos = photos.filter(e => e.is_archived === undefined || e.is_archived === null || e.is_archived === false);

        if (photos && photos.length) {
            photos.map(function (photo, i) {
                if (photo.kind === 'Driver') {
                    driver_photos.push(<Avatar key={photo._id} className="border-shadows pointer" onClick={this.showModalForAvatar} src={photo.picture} data-id={i} shape="square" size="large" style={{ margin: 15 }} />);
                    return driver_photos;
                }
                if (photo.kind === 'Advert') {
                    advert_photos.push(<Avatar key={photo._id} className="border-shadows pointer" onClick={this.showModalForAvatar} src={photo.picture} data-id={i} shape="square" size="large" style={{ margin: 15 }} />);
                    return advert_photos;
                }
                if (photo.kind === 'Blemish Report') {
                    if (photo.blemish_report_question && photo.blemish_report_question !== '') {
                        br_photos.push(
                            <div key={photo._id}>
                                <Avatar className="border-shadows pointer" onClick={this.showModalForAvatar} src={photo.picture} data-id={i} shape="square" size="large" style={{ margin: 15 }} />
                                <span>
                                    <span style={{ fontStyle: 'italic', fontWeight: 300 }}>Question:&nbsp;</span>
                                    {photo.blemish_report_question}
                                </span>
                            </div>,
                        );
                        return br_photos;
                    }

                    br_photos.push(<Avatar key={photo._id} className="border-shadows pointer" onClick={this.showModalForAvatar} data-id={i} src={photo.picture} shape="square" size="large" style={{ margin: 15 }} />);
                    return br_photos;
                }
                if (photo.kind === 'Settlement Documents') {
                    settlement_docs.push(<Avatar key={photo._id} className="border-shadows pointer" onClick={this.showModalForAvatar} data-id={i} src={photo.picture} shape="square" size="large" style={{ margin: 15 }} />);
                    return settlement_docs;
                }

                return <span>No Photos</span>;
            }, this);
        }

        return (
            <Fragment>
                <div style={{ marginBottom: 25 }}>
                    <Select
                        allowClear
                        placeholder="Choose Photo Type"
                        onChange={this.choosePhotoType}
                        style={{ width: 175, marginRight: 15 }}
                    >
                        {photo_types.map((type, index) => <Option key={index} value={type}>{type}</Option>)}
                    </Select>
                    <Upload showUploadList={false} customRequest={this.photoUploadHandler} accept={this.state.photo_type === 'Settlement Documents' ? 'image/*, application/pdf' : 'image/*'}>
                        <Button disabled={!this.state.photo_type}>
                            <Icon type="upload" />
                            {' '}
                            Upload Photo
                        </Button>
                    </Upload>
                </div>
                <Spin spinning={loading} tip="Photo is uploading...">
                    <h3 style={photos_types_styles.heading}>Driver</h3>
                    {
                        driver_photos.length
                            ? driver_photos
                            : <div style={photos_types_styles.default}>No Driver Photos</div>
                    }
                    <h3 style={photos_types_styles.heading}>Advert</h3>
                    {
                        advert_photos.length
                            ? advert_photos
                            : <div style={photos_types_styles.default}>No Advert Photos</div>
                    }
                    <h3 style={photos_types_styles.heading}>Blemish Report</h3>
                    {
                        br_photos.length
                            ? br_photos
                            : <div style={photos_types_styles.default}>No Blemish Report Photos</div>
                    }
                    <h3 style={photos_types_styles.heading}>Settlement Documents</h3>
                    {
                        settlement_docs.length
                            ? settlement_docs
                            : <div style={photos_types_styles.default}>No Settlement Documents</div>
                    }
                </Spin>
                <Modal
                    visible={this.state.visible}
                    footer={null}
                    onCancel={this.handleCancel}
                    width={850}
                >
                    {photos && photos.length
                        && photos.map(function (photo, i) {
                            return (
                                <Fragment key={i}>
                                    {this.state.photo_address === photo.picture
                                    && (
                                        <>
                                            {is_user_admin_or_super_user
                                        && (
                                            <p className="text-align-center margin-bottom-10-px">
                                                <a
                                                    href="#"
                                                    data-src={photo.picture}
                                                    data-id={i}
                                                    onClick={this.deletePhoto}
                                                >
                                                    Delete
                                                    Photo
                                                </a>
                                            </p>
                                        )
                                            }
                                            <div style={{ width: '5%', display: 'inline-block' }}>
                                                {i > 0
                                            && (
                                                <a
                                                    href="#"
                                                    onClick={this.changePhoto}
                                                    data-picture={photos[i - 1] ? photos[i - 1].picture : ''}
                                                >
                                                    &#8678;
                                                </a>
                                            )
                                                }
                                            </div>

                                            <div style={{ width: '90%', display: 'inline-block' }}><img style={{ width: '100%' }} src={photo.picture} alt="bike_photo" /></div>

                                            <div style={{ width: '5%', display: 'inline-block', textAlign: 'right' }}>
                                                {i < (photos.length - 1)
                                            && (
                                                <a
                                                    href="#"
                                                    onClick={this.changePhoto}
                                                    data-picture={photos[i + 1] ? photos[i + 1].picture : ''}
                                                >
                                                    &#8680;
                                                </a>
                                            )
                                                }
                                            </div>
                                        </>
                                    )
                                    }
                                </Fragment>
                            );
                        }, this)
                    }

                </Modal>
            </Fragment>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_photos/Lead_profile_photos.js